import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { getSkillLevel, getSkillLevelRequiredXp, SkillProps, SkillsByName } from '../../services/skill';
import { TaskRewardProps } from '../../services/task';
import Icon from '../../ui/Icon';
import ProgressBar from '../../ui/Progress/ProgressBar';
import { stores, useStore } from '../../utils/store';

interface Props {
    reward: TaskRewardProps
}

export default function SkillNotification({ reward }: Props) {
    const [addedXp, setAddedXp] = useState(0);
    const addedXpRef = useRef(0);

    const [skills,] = useStore(stores.skills);
    const skill = skills.find(skill => skill.id === reward.type) as SkillProps;
    const xpTotal = skill.xpTotal - reward.xp + addedXp;

    const currentLevel = getSkillLevel(xpTotal);
    const currentLevelXp = xpTotal - getSkillLevelRequiredXp(currentLevel);
    const currentLevelXpNeeded = getSkillLevelRequiredXp(currentLevel + 1) - getSkillLevelRequiredXp(currentLevel)

    useEffect(() => {
        setAddedXp(0);
        addedXpRef.current = 0;
        function addXp() {
            let newAddedXp = addedXpRef.current;
            // debugger;
            if (newAddedXp < reward.xp) {
                newAddedXp = Math.min(newAddedXp + 0.1, reward.xp);
                addedXpRef.current = newAddedXp;
                setAddedXp(newAddedXp)
                timeout = setTimeout(addXp, 100);
            }
        }
        let timeout = setTimeout(addXp, 100 + 400);
    }, [reward]);

    return (
        <Wrapper>
            <div className='skill-notification-icon'>
                <Icon icon={SkillsByName[reward.type].icon}></Icon>
                <div className='skill-notification-lvl'>Lvl. {currentLevel}</div>
            </div>

            <div className='skill-notification-progress'>
                <div className='skill-notification-xp'>{currentLevelXp.toFixed(1)} / {currentLevelXpNeeded.toFixed(1)}</div>
                <ProgressBar className='skill-notification-progress-bar' size={4} value={(currentLevelXp / currentLevelXpNeeded) * 100}></ProgressBar>
                <div className='skill-notification-xp-added'>+ {reward.xp.toFixed(1)} xp</div>
            </div>

            <div className='skill-notification-icon'>
                <Icon icon={SkillsByName[reward.type].icon}></Icon>
                <div className='skill-notification-lvl'>Lvl. {currentLevel + 1}</div>
            </div>
        </Wrapper>
    )
}

const Wrapper = styled.div`
    display: flex;

    .skill-notification-icon {
        padding: 10px;
        border-radius: ${props => props.theme.borderRadius}
    }

    .skill-notification-lvl {
        font-size: 13px;
        font-weight: 700;
        color: #ffffff;
    }

    .skill-notification-progress {
        width: 200px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .skill-notification-xp {
        font-size: 12px;
        font-weight: 700;
        text-align: center;
    }

    .skill-notification-progress-bar {
        margin: 4px 0;
    }

    .skill-notification-xp-added {
        font-size: 14px;
        font-weight: 900;
        text-align: center;
    }
`